export default "__VITE_ASSET__DRwFLQAQ__"